import { createFileRoute, redirect } from '@tanstack/react-router';
import { findNavItem } from '@/shared/patterns/AppShell';
import { salesNav } from '@/domains/sales';
import { UnderConstruction } from '@/shared/components/UnderConstruction';
import { SalesMySales } from '@/domains/sales/portal/SalesMySales';
import { SalesCatalog } from '@/domains/sales/portal/SalesCatalog';
import { SalesPhones } from '@/domains/sales/portal/SalesPhones';
import { SalesPhoneSale } from '@/domains/sales/portal/SalesPhoneSale';
import { SalesAccessories } from '@/domains/sales/portal/SalesAccessories';
import { SalesCollections } from '@/domains/sales/portal/SalesCollections';
import { SalesQuoter } from '@/domains/sales/portal/quoter/SalesQuoter';
import { SalesCustomers } from '@/domains/sales/portal/SalesCustomers';
import { SalesKycPending } from '@/domains/sales/portal/SalesKycPending';
import { SalesStore } from '@/domains/sales/portal/SalesStore';
import { SalesMyCommissions } from '@/domains/sales/portal/SalesMyCommissions';
import { SalesRefunds } from '@/domains/sales/portal/SalesRefunds';
import {
    legacySectionRedirect,
    parseSalesSectionSearch,
} from '@/domains/sales/portal/salesSectionSearch';

// Cada sección del portal despacha a su pantalla; las que aún no existen caen a UnderConstruction.
export const Route = createFileRoute('/_backoffice/sales/$section')({
    validateSearch: parseSalesSectionSearch,
    // `/sales/prospects` ya es la pestaña Prospectos de Clientes: se redirige antes de pintar nada.
    beforeLoad: ({ params, search }) => {
        const target = legacySectionRedirect(params.section, search);
        if (target === null) return;
        throw redirect({
            to: '/sales/$section',
            params: { section: target.section },
            search: target.search,
            replace: true,
        });
    },
    component: SalesSection,
});

function SalesSection() {
    const { section } = Route.useParams();
    // Deep-links: `?prospect=`, `?customer=`, `?sale=` y `?sku=` abren esa ficha en su explorer.
    const { tab, prospect, customer, sale, sku } = Route.useSearch();
    switch (section) {
        case 'my-sales':
            return <SalesMySales saleId={sale} />;
        case 'customers':
            return (
                <SalesCustomers
                    tab={tab ?? 'customers'}
                    customerId={customer}
                    prospectId={prospect}
                />
            );
        case 'kyc-pending':
            return <SalesKycPending />;
        case 'catalog':
            return <SalesCatalog sku={sku} />;
        case 'phone-sale':
            return <SalesPhoneSale />;
        case 'phones':
            return <SalesPhones sku={sku} />;
        case 'accessories':
            return <SalesAccessories />;
        case 'collections':
            return <SalesCollections />;
        case 'quoter':
            return <SalesQuoter />;
        case 'my-store':
            return <SalesStore />;
        case 'my-commissions':
            return <SalesMyCommissions />;
        case 'refunds':
            return <SalesRefunds />;
        default:
            return <UnderConstruction title={findNavItem(salesNav, section)?.label ?? section} />;
    }
}
